<template>
  <v-card flat  class="setup-subtab-content">

    <div class="">

    <div class="pb-3" v-html="$t('setup.excludedDescription')">
    </div>

    <v-card flat>
      <div class="d-flex pt-3">
        <v-btn color="primary" @click="" :href="csvUrl">
          <v-icon left>mdi-download</v-icon>
          {{ $t('setup.excludedTitlesButton') }}
        </v-btn>
      </div>
    </v-card>

    </div>
  </v-card>
</template>


<script>
import _ from "lodash"
import {mapGetters, mapMutations, mapActions} from 'vuex'
import {urlBase} from "../../api";
import PublisherFile from "../PulisherFile/PublisherFile";
import PublisherWarning from "@/components/PublisherWarning/PublisherWarning";

export default {
  name: "PublisherSetupTabExcluded",
  components: {
    PublisherFile,
    PublisherWarning,
  },
  props: {},
  data() {
    return {}
  },
  methods: {},
  computed: {
    ...mapGetters([
      "publisherName",
      "publisherId",
      "publisherBigDealCost",
      "publisherFiles",
      "getPublisherDataFile",
      "publisherCounterVersion",
    ]),
    csvUrl() {
      // urlBase ends with a slash
      let url = `${urlBase}publisher/${this.publisherId}/excluded`;
      url += "?timestamp=" + `${new Date().getTime()}`
      url += "&jwt=" + localStorage.getItem("token")
      return url
    },
  },
  created() {
  },
  mounted() {

  },
  watch: {}
}
</script>

<style lang="scss">


</style>
